import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        benefitStack: {
            align: 'stretch',
            gap: ['xxsmall-1.base', 'xxsmall-1.sm', 'xxsmall-1.md', 'xxsmall-1.lg'],
            pb: ['xsmall.base', 'xsmall.sm', 'xsmall.md', 'xsmall.lg'],
        },
        icon: {
            boxSize: remCalc(16),
            color: 'foreground.neutral.default',
        },
        preorderText: {
            fontWeight: 'medium',
            color: 'foreground.neutral.default',
            textStyle: 'body-small',
        },
    },
    parts: ['icon', 'preorderText'],
}
